import { size, isEmpty } from "lodash"

export function getStrengthText(strength) {
  switch (strength) {
    case 0:
    case 1:
      return "Too weak"
    case 2:
      return "Almost there"
    case 3:
      return "Strong"
    case 4:
      return "Strongest"
  }
}

export function getPasswordStrength(password, testResult) {
  if (size(password) === 0) {
    return null
  }

  if (testResult.isPassphrase) {
    // A passphrase but didn't pass all the required tests
    if (!testResult.strong) {
      return 2
    }

    return 4
  }

  // Still weak : doesn't pass the required tests but do pass some optional tests
  if (!isEmpty(testResult.requiredTestErrors) && testResult.optionalTestsPassed >= 2) {
    return 1
  }

  if (isEmpty(testResult.requiredTestErrors)) {
    // average : Doesn't pass at least three optional tests
    if (!testResult.strong) {
      return 2
    }

    if (testResult.optionalTestsPassed === 3) {
      // Strong : pass 3 out of 4 optional tests
      return 3
    }

    return 4
  }

  // Weak
  return 0
}
